<div class="basic-cell" fxLayout="row" fxLayoutAlign="start center">
  <span [ngClass]="{ capitalize: $safeNavigationMigration(params()?.cellOptions?.capitalize) }" class="basic-cell">
    <span>{{ params()?.value }}</span>
  </span>
</div>
